<template>
    <el-container style="height: calc(100vh - 52px)">
        <el-header style="height: auto;" class="bg-gray-200 p-3 md:p-5">
            <div class="flex w-full flex-col md:flex-row">
                <!-- 検索部 -->
                <div class="hidden md:block bg-white border-2 border-gray-400 rounded-md p-4">
                    <el-form :model="searchForm" label-width="auto" label-position="top">
                        <div class="grid gap-4" :class="[
                            loginUserRole === ROLES.SYSTEM ? 'md:grid-cols-4' : loginUserRole === ROLES.ADMIN && loginUserRoleIsHead ? 'md:grid-cols-3' : 'md:grid-cols-2',
                        ]">
                            <el-form-item class="no-margin" v-show="loginUserRole === ROLES.SYSTEM" label="組織">
                                <OrganizationSelect v-model="searchForm.organization_id" :is-search="true"
                                    placeholder="組織を選択" />
                            </el-form-item>

                            <el-form-item class="no-margin"
                                v-show="loginUserRole === ROLES.SYSTEM || (loginUserRole === ROLES.ADMIN && loginUserRoleIsHead)"
                                label="部門">
                                <DepartmentSelect :organization-id="searchForm.organization_id" :is-search="true"
                                    v-model="searchForm.department_id" placeholder="部門を選択" @organization-id-change="searchForm.organization_id = $event" />
                            </el-form-item>

                            <el-form-item class="no-margin" label="ユーザー名">
                                <AutoCompleteInput v-model="searchForm.username" placeholder="ユーザー名を入力"
                                    storage-key="user-name-history" :max-history-items="15" ref="usernameInput" />
                            </el-form-item>

                            <div class="flex justify-end mt-7">
                                <el-button class="hidden md:block w-24" type="info"
                                    @click="handleSearchButton">検索</el-button>
                            </div>
                        </div>
                    </el-form>
                </div>

                <el-drawer class="md:hidden bg-gray-200" v-model="drawer" title="検索" direction="ttb"
                    :with-header="false" size="auto">
                    <div class="bg-white border-2 border-gray-400 rounded-md p-4">
                        <el-form :model="searchForm" label-width="auto" label-position="top">
                            <div class="grid gap-4">
                                <el-form-item class="no-margin" v-show="loginUserRole === ROLES.SYSTEM" label="組織">
                                    <OrganizationSelect v-model="searchForm.organization_id" :is-search="true"
                                        placeholder="組織を選択" />
                                </el-form-item>

                                <el-form-item class="no-margin"
                                    v-show="loginUserRole === ROLES.SYSTEM || (loginUserRole === ROLES.ADMIN && loginUserRoleIsHead)"
                                    label="部門">
                                    <DepartmentSelect :organization-id="searchForm.organization_id" :is-search="true"
                                        v-model="searchForm.department_id" placeholder="部門を選択" @organization-id-change="searchForm.organization_id = $event" />
                                </el-form-item>

                                <div class="flex">
                                    <el-form-item class="no-margin flex-grow" label="ユーザー名">
                                        <AutoCompleteInput v-model="searchForm.username" placeholder="ユーザー名を入力"
                                            storage-key="user-name-history" :max-history-items="15"
                                            ref="usernameInput" />
                                    </el-form-item>

                                    <div class="flex justify-end mt-7">
                                        <el-button class="md:hidden ml-3" type="info" @click="handleSearchButton"
                                            circle>
                                            <el-icon>
                                                <span class="material-symbols-outlined">manage_search</span>
                                            </el-icon>
                                        </el-button>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                    </div>
                </el-drawer>

                <!-- 操作部 -->
                <div class="flex justify-end items-center md:flex-grow">
                    <el-button class="custom-icon-btn md:hidden" type="info" @click="drawer = true" circle>
                        <span class="material-symbols-outlined">
                            manage_search
                        </span>
                    </el-button>

                    <el-button class="custom-icon-btn md:hidden" type="info" @click="handleAddButton" circle
                        v-if="loginUserRole === ROLES.SYSTEM">
                        <span class="material-symbols-outlined">
                            add
                        </span>
                    </el-button>
                    <el-button class="hidden md:block w-24" type="info" @click="handleAddButton"
                        v-if="loginUserRole === ROLES.SYSTEM">新規登録</el-button>


                    <el-upload class="" ref="upload" :on-change="handleImportButton" :auto-upload="false"
                        :show-file-list="false" accept=".csv" v-if="loginUserRole === ROLES.SYSTEM">
                        <el-tooltip content="CSVインポート" placement="top">
                            <el-button class="custom-icon-btn mx-3" type="info" circle>
                                <span class="material-symbols-outlined">
                                    upload_2
                                </span>
                            </el-button>
                        </el-tooltip>
                    </el-upload>

                    <el-button class="custom-icon-btn" type="info" @click="handleExportButton" circle>
                        <el-tooltip content="CSVエクスポート" placement="top">
                            <span class="material-symbols-outlined">
                                download_2
                            </span>
                        </el-tooltip>
                    </el-button>
                </div>
            </div>
        </el-header>

        <el-mian style="padding-bottom: 20px;">
            <!-- 手机CARD部 -->
            <div class="md:hidden" v-loading="loading" style="height: calc(100vh - 177px)">
                <div class="custom-title flex flex-col">
                    <span>ユーザーマスタ（ユーザー名　役割）</span>
                    <div class="ml-auto">
                        <div class="flex items-center space-x-1">
                            <span class="text-white">ソート:</span>
                            <el-button size="small" @click="handleSort('username')"
                                :class="['mobile-sort-btn', sortField === 'username' ? 'active' : '']">
                                ユーザー名
                            </el-button>
                            <span>アイテム数: {{ mTotalRecords }}</span>
                        </div>
                    </div>
                </div>

                <div style="height: calc(100vh - 227px); overflow-y: auto;">
                    <el-card style="border: 1px solid #d1d5db; border-radius: 0px" v-for="item in mTableData"
                        :key="item.user_id">
                        <el-row align="middle">
                            <el-col :span="2">
                                <el-button class="w-8 h-16" type="info" style="background-color: #b7b7b7;" text bg
                                    @click="handleEditButton(item)">
                                    <span>詳<br>細</span>
                                </el-button>
                            </el-col>

                            <el-col :span="18" class="ml-2">
                                <el-row align="middle">
                                    <div class="flex-grow" v-if="loginUserRole === ROLES.SYSTEM">{{
                                        item.organization_name }}</div>
                                    <div
                                        v-if="loginUserRole === ROLES.SYSTEM || (loginUserRole === ROLES.ADMIN && loginUserRoleIsHead)">
                                        {{ item.department_name }}</div>
                                </el-row>
                                <div>{{ item.username }}</div>
                                <el-row align="middle" justify="space-between">
                                    <div>
                                        <el-tag
                                            v-if="item.organization_id === SYSTEM_ORGANIZATION && item.is_admin === '1'"
                                            type="warning">システム管理者</el-tag>
                                        <el-tag v-else-if="item.is_admin === '1'" type="danger">管理者</el-tag>
                                        <el-tag v-else type="success">ユーザー</el-tag>
                                    </div>
                                    <div>
                                        <el-switch v-model="item.is_actived" value="item.is_actived" active-value="1"
                                            inactive-value="0"
                                            :disabled="loginUserId === item.user_id || (item.organization_id === SYSTEM_ORGANIZATION && item.is_admin === '1')"
                                            @change="handleStatusChange(item)" />
                                    </div>
                                </el-row>
                            </el-col>

                            <el-col :span="2" class="ml-2" align="right">
                                <span
                                    v-if="loginUserId !== item.user_id && !(item.organization_id === SYSTEM_ORGANIZATION && item.is_admin === '1')"
                                    class="material-symbols-outlined cursor-pointer mt-2"
                                    @click="handleDeleteButton(item)">
                                    delete
                                </span>
                            </el-col>
                        </el-row>
                    </el-card>
                </div>
            </div>

            <!-- WEB表格部 -->
            <div class="hidden md:block w-full">
                <el-table :data="mTableData" height="calc(100vh - 260px)" v-loading="loading">
                    <el-table-column label="ユーザーマスタ" width="130" align="center">
                        <template #default="scope">
                            <el-button class="w-12" type="info" style="background-color: #b7b7b7;" text bg
                                @click="handleEditButton(scope.row)">
                                <span>詳細</span>
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="user_id" label="コード">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap"
                                @click="handleSort('user_id')">
                                <span>{{ getSortLabel('user_id') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm"
                                        :class="{ 'text-blue-500': sortField === 'user_id' }">
                                        {{ getSortIcon('user_id') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="loginUserRole === ROLES.SYSTEM" prop="organization_name" label="所属組織">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap"
                                @click="handleSort('organization_name')">
                                <span>{{ getSortLabel('organization_name') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm"
                                        :class="{ 'text-blue-500': sortField === 'organization_name' }">
                                        {{ getSortIcon('organization_name') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="loginUserRole === ROLES.SYSTEM || (loginUserRole === ROLES.ADMIN && loginUserRoleIsHead)"
                        prop="department_name" label="所属部門">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap"
                                @click="handleSort('department_name')">
                                <span>{{ getSortLabel('department_name') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm"
                                        :class="{ 'text-blue-500': sortField === 'department_name' }">
                                        {{ getSortIcon('department_name') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="username" label="ユーザー名">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap"
                                @click="handleSort('username')">
                                <span>{{ getSortLabel('username') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm"
                                        :class="{ 'text-blue-500': sortField === 'username' }">
                                        {{ getSortIcon('username') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="is_admin" label="役割">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('role')">
                                <span>{{ getSortLabel('role') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm"
                                        :class="{ 'text-blue-500': sortField === 'role' }">
                                        {{ getSortIcon('role') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                        <template #default="scope">
                            <el-tag :type="(scope.row.organization_id === SYSTEM_ORGANIZATION && scope.row.is_admin === '1')
                                ? 'warning'
                                : (scope.row.is_admin === '1' ? 'danger' : 'success')">
                                {{ (scope.row.organization_id === SYSTEM_ORGANIZATION && scope.row.is_admin === '1')
                                    ? 'システム管理者'
                                    : (scope.row.is_admin === '1' ? '管理者' : 'ユーザー') }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="email" label="メールアドレス">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap"
                                @click="handleSort('email')">
                                <span>{{ getSortLabel('email') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm"
                                        :class="{ 'text-blue-500': sortField === 'email' }">
                                        {{ getSortIcon('email') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="is_actived" label="有効/無効" width="86" align="center">
                        <template #default="scope">
                            <el-switch v-model="scope.row.is_actived" value="scope.row.is_actived" active-value="1"
                                inactive-value="0"
                                :disabled="loginUserId === scope.row.user_id || (scope.row.organization_id === SYSTEM_ORGANIZATION && scope.row.is_admin === '1')"
                                @change="handleStatusChange(scope.row)" />
                        </template>
                    </el-table-column>
                    <el-table-column label="削除" width="52" align="center" v-if="loginUserRole === ROLES.SYSTEM">
                        <template #default="scope">
                            <span
                                v-if="loginUserId !== scope.row.user_id && !(scope.row.organization_id === SYSTEM_ORGANIZATION && scope.row.is_admin === '1')"
                                class="material-symbols-outlined cursor-pointer mt-2"
                                @click="handleDeleteButton(scope.row)">
                                delete
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 分页部 -->
            <div class="flex w-full justify-end mt-4">
                <div class="hidden md:block mr-3">
                    <el-pagination v-model:current-page="mCurrentPage" v-model:page-size="mPageSize"
                        :page-sizes="[10, 20, 50, 100]" layout="total, sizes, prev, pager, next, jumper"
                        :total="mTotalRecords" @size-change="handleSizeChange" @current-change="handlePageChange" />
                </div>

                <div class="md:hidden">
                    <el-pagination layout="prev, pager, next" :total="mTotalRecords"
                        @current-change="handlePageChange" />
                </div>
            </div>
        </el-mian>
    </el-container>

    <!-- 新規登録更新对话框 -->
    <el-dialog class="custom-dialog" modal-class="custom-dialog-modal" v-model="dialogFormVisible"
        :title="form.add_update === 'add' ? '新規登録' : '詳細'" align-center>
        <el-form :model="form" :rules="rules" ref="formRef">
            <el-form-item label="コード" prop="user_id" label-width="130px">
                <el-input v-model="form.user_id" autocomplete="off" :disabled="form.add_update === 'update'"
                    placeholder="コード" />
            </el-form-item>
            <el-form-item label="ユーザー名" prop="username" label-width="130px">
                <el-input v-model="form.username" autocomplete="off" placeholder="ユーザー名" />
            </el-form-item>
            <el-form-item label="メールアドレス" prop="email" label-width="130px">
                <el-input v-model="form.email" autocomplete="off" placeholder="メールアドレス" />
            </el-form-item>
            <el-form-item label="パスワード" prop="password" label-width="130px">
                <el-input show-password v-model="form.password" autocomplete="off" :placeholder="isEdit ? '変更する場合のみ入力' : 'パスワード'" />
            </el-form-item>
            <el-form-item label="所属組織" prop="organization_id" v-if="loginUserRole === ROLES.SYSTEM" label-width="130px">
                <OrganizationSelect v-model="form.organization_id" placeholder="組織を選択"
                    :disabled="form.add_update === 'update'" />
            </el-form-item>
            <el-form-item label="所属部門" prop="department_id" v-if="loginUserRole === ROLES.SYSTEM" label-width="130px">
                <DepartmentSelect :organization-id="form.organization_id" v-model="form.department_id"
                    placeholder="部門を選択" :disabled="form.add_update === 'update'" @organization-id-change="form.organization_id = $event" />
            </el-form-item>
            <el-form-item label="役割" label-width="130px">
                <el-select v-model="form.is_admin" placeholder="役割を選択">
                    <el-option label="管理者" value="1" />
                    <el-option label="一般ユーザー" value="0" />
                </el-select>
            </el-form-item>
            <el-form-item label="有効/無効" label-width="130px">
                <el-select v-model="form.is_actived" placeholder="ステータスを選択"
                    :disabled="form.add_update === 'update' && (loginUserId === form.user_id || form.organization_id === SYSTEM_ORGANIZATION && form.is_admin === '1')">
                    <el-option label="有効" value="1" />
                    <el-option label="無効" value="0" />
                </el-select>
            </el-form-item>
        </el-form>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="dialogFormVisible = false">キャンセル</el-button>
                <el-button type="primary" @click="handleAddUpdateSubmit(formRef)">
                    {{ form.add_update === 'add' ? '登録' : '更新' }}
                </el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script lang="ts">
import axios, { AxiosResponse } from 'axios';
import { ElMessage, ElMessageBox, ElPagination, ElTable, ElTableColumn, ElSwitch } from 'element-plus';
import { defineComponent, onMounted, ref, nextTick } from 'vue';
import OrganizationSelect from '@/components/common/OrganizationSelect.vue';
import DepartmentSelect from '@/components/common/DepartmentSelect.vue';
import type { FormInstance, FormRules, UploadFile } from 'element-plus'
import { Delete, Edit, Search, Plus } from '@element-plus/icons-vue';
import { ErrorCode, ImportResponseData, ResponseData, ResponseStatus } from '@/components/common/response';
import { getErrorMessage, PageType } from '@/components/common/errorMessage';
import { Operation, SearchRequest } from '@/components/common/request';
import router from '@/router';
import moment from 'moment';
import { ALL, CSV_MAX_SIZE, ROLES, ROUTES, SYSTEM_ORGANIZATION } from '@/config/constants';
import AutoCompleteInput from '@/components/common/AutoCompleteInput.vue';
import { sortingUtil, SortConfig } from '@/components/common/SortingUtil';

interface UserInfo {
    add_update?: Operation,
    user_id: string,
    username: string,
    password: string,
    organization_id: string,
    department_id: string,
    email: string,
    role?: string,
    is_actived: string,
    is_admin: string,
    organization_name?: string,
    department_name?: string,
}


export default defineComponent({
    name: 'MngUser',
    components: {
        ElTable,
        ElTableColumn,
        ElSwitch,
        ElPagination,
        OrganizationSelect,
        DepartmentSelect,
        Delete,
        Plus,
        Edit,
        Search,
        AutoCompleteInput,
    },
    setup() {
        const searchForm = ref<any>({
            username: '',
            organization_id: ALL,
            department_id: ALL,
        });

        const form = ref<UserInfo>({
            add_update: Operation.unknow,
            user_id: '',
            username: '',
            password: '',
            organization_id: '',
            department_id: '',
            email: '',
            role: '',
            is_actived: '0',
            is_admin: '0',
        });

        const drawer = ref(false);

        const loading = ref(false);

        const isEdit = ref(false);
        const dialogFormVisible = ref<boolean>(false);
        const formRef = ref<FormInstance>();
        const rules = ref<FormRules>({
            user_id: [
                { required: true, message: 'コードを入力してください', trigger: 'blur' },
                { min: 1, max: 20, message: 'コードは1〜20文字の間で入力してください', trigger: 'blur' }
            ],
            username: [
                { required: true, message: 'ユーザー名を入力してください', trigger: 'blur' },
                { min: 2, max: 50, message: 'ユーザー名は2〜50文字の間で入力してください', trigger: 'blur' }
            ],
            email: [
                { required: true, message: 'メールアドレスを入力してください', trigger: 'blur' },
                { type: 'email', message: '有効なメールアドレスを入力してください', trigger: ['blur', 'change'] }
            ],
            password: [
                {
                    required: true,
                    // message: 'パスワードを入力してください', 
                    validator: (_rule: any, value: string, callback: any) => {
                        if (!isEdit.value && !value) {
                            callback(new Error('パスワードを入力してください'));
                        } else {
                            callback();
                        }
                    },
                    trigger: 'blur'
                },
                { min: 6, max: 20, message: 'パスワードは6〜20文字の間で入力してください', trigger: 'blur' }
            ],
            organization_id: [
                { required: true, message: '所属組織を選択してください', trigger: 'change' }
            ],
            department_id: [
                { required: true, message: '所属部門を選択してください', trigger: 'change' }
            ]
        });

        const sortConfig: SortConfig = {
            user_id: {
                label: 'コード',
                mobileLabel: 'コード',
                type: 'string' as const,
                defaultOrder: 'asc' as const
            },
            username: {
                label: 'ユーザー名',
                mobileLabel: 'ユーザー名',
                type: 'string' as const,
                defaultOrder: 'asc' as const
            },
            email: {
                label: 'メールアドレス',
                mobileLabel: 'メールアドレス',
                type: 'string' as const,
                defaultOrder: 'asc' as const
            },
            password: {
                label: 'パスワード',
                mobileLabel: 'パスワード',
                type: 'string' as const,
                defaultOrder: 'asc' as const
            },
            organization_name: {
                label: '所属組織',
                mobileLabel: '所属組織',
                type: 'string' as const,
                defaultOrder: 'asc' as const
            },
            department_name: {
                label: '所属部門',
                mobileLabel: '所属部門',
                type: 'string' as const,
                defaultOrder: 'asc' as const
            },
            is_admin: {
                label: '役割',
                mobileLabel: '役割',
                type: 'string' as const,
                defaultOrder: 'asc' as const
            },
            role: {
                label: '役割',
                mobileLabel: '役割',
                type: 'string' as const,
                defaultOrder: 'asc' as const
            },
            is_actived: {
                label: '有効/無効',
                mobileLabel: '有効/無効',
                type: 'string' as const,
                defaultOrder: 'asc' as const
            },
        };

        const allUsers = ref<UserInfo[]>([]);

        const {
            handleSort,
            getSortLabel,
            getSortIcon,
            paginatedData: mTableData,
            totalRecords: mTotalRecords,
            totalPages: mTotalPages,
            currentPage: mCurrentPage,
            pageSize: mPageSize,
            handleSizeChange,
            handlePageChange,
            showMoreDataAlert,
            sortField,
            sortOrder,
        } = sortingUtil(
            allUsers,
            sortConfig,
        );

        const loginUserRole = localStorage.getItem('role');
        const loginUserId = localStorage.getItem('user_id');
        const loginUserRoleIsHead = localStorage.getItem('is_head') === '1';

        const usernameInput = ref<any>(null);

        onMounted(() => {
            //  如果没有信息，重新登陆
            if (!loginUserRole) {
                router.push(`/${ROUTES.LOGIN}`);
            }
            getUserList();
        });

        const handleSearchButton = () => {
            drawer.value = false;

            if (usernameInput.value) {
                usernameInput.value.submitValue();
            }
            getUserList();
        };

        const handleAddButton = () => {
            isEdit.value = false;
            dialogFormVisible.value = true;
            nextTick(() => {
                formRef.value?.resetFields();
                form.value = {
                    add_update: Operation.add,
                    user_id: '',
                    username: '',
                    password: '',
                    organization_id: '',
                    department_id: '',
                    email: '',
                    is_actived: '0',
                    is_admin: '0'
                };
            });
        };

        const handleStatusChange = (row: UserInfo) => {
            form.value = {
                add_update: Operation.update,
                user_id: row.user_id,
                username: row.username,
                password: row.password,
                organization_id: row.organization_id.toString(),
                department_id: row.department_id.toString(),
                email: row.email,
                role: row.role,
                is_actived: row.is_actived,
                is_admin: row.is_admin,
            };
            updateUser();
        };

        const handleEditButton = (row: UserInfo) => {
            isEdit.value = true;
            dialogFormVisible.value = true;
            nextTick(() => {
                formRef.value?.resetFields();
                form.value = {
                    add_update: Operation.update,
                    user_id: row.user_id,
                    username: row.username,
                    password: '',
                    organization_id: row.organization_id.toString(),
                    department_id: row.department_id.toString(),
                    email: row.email,
                    role: row.role,
                    is_actived: row.is_actived,
                    is_admin: row.is_admin,
                };
            });
        };

        const handleDeleteButton = (row: UserInfo) => {
            ElMessageBox.confirm('削除しますか？', '削除', {
                confirmButtonText: '削除',
                cancelButtonText: 'キャンセル',
                type: 'warning',
            }).then(() => {
                deleteUser(row);
            }).catch(() => {
                // console.log('削除キャンセル');
            });
        };

        const handleAddUpdateSubmit = async (formEl: FormInstance | undefined) => {
            if (!formEl) return
            await formEl.validate((valid, fields) => {
                if (valid) {
                    if (form.value.add_update === Operation.add) {
                        addUser();
                    } else if (form.value.add_update === Operation.update) {
                        updateUser();
                    }
                    dialogFormVisible.value = false;
                }
            })
        }

        const getUserList = async () => {
            try {
                loading.value = true;
                const params: SearchRequest = {
                    username: searchForm.value.username,
                    organization_id: searchForm.value.organization_id === ALL ? '' : searchForm.value.organization_id,
                    department_id: searchForm.value.department_id === ALL ? '' : searchForm.value.department_id,
                };

                const res: AxiosResponse<ResponseData<UserInfo[]>> = await axios.get('/api/users/search', { params });
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    const { data, hasMoreData } = res.data;

                    allUsers.value = (data || []).map((user: any) => ({
                        ...user,
                        is_admin: String(user.is_admin),
                        role: user.is_admin === '1' && user.organization_id === SYSTEM_ORGANIZATION ? '0'
                            : user.is_admin === '1' ? '1' : '2',
                        is_actived: String(user.is_actived),
                    }));
                    showMoreDataAlert(hasMoreData || false);
                } else {
                    ElMessage.error(getErrorMessage(PageType.USER, res.data.code));
                }
            } catch (error) {
                ElMessage.error(getErrorMessage(PageType.USER));
            } finally {
                loading.value = false;
            }
        };

        const addUser = async () => {
            try {
                const res: AxiosResponse<ResponseData<UserInfo>> = await axios.post('/api/users', form.value);
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    getUserList();
                } else {
                    ElMessage.error(getErrorMessage(PageType.USER, res.data.code));
                }
            }
            catch (error) {
                ElMessage.error(getErrorMessage(PageType.USER));
            }
        };

        const updateUser = async () => {
            try {
                const res: AxiosResponse<ResponseData<UserInfo>> = await axios.put(`/api/users/${form.value.user_id}`, form.value);
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    getUserList();
                } else {
                    ElMessage.error(getErrorMessage(PageType.USER, res.data.code));
                }
            }
            catch (error) {
                ElMessage.error(getErrorMessage(PageType.USER,));
            }
        };

        const deleteUser = async (row: UserInfo) => {
            try {
                const res: AxiosResponse<ResponseData> = await axios.delete(`/api/users/${row.user_id}`);
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    getUserList();
                } else {
                    ElMessage.error(getErrorMessage(PageType.USER, res.data.code));
                }
            }
            catch (error) {
                ElMessage.error(getErrorMessage(PageType.USER));
            }
        };

        const exportUser = async () => {
            try {
                const res: AxiosResponse<any> = await axios.post(`/api/users/export`, {
                    responseType: 'blob'  // 设置响应类型为 blob
                });
                if (res.status === ResponseStatus.SUCCESS && res.data.code === undefined) {
                    // 创建 Blob 对象并触发文件下载
                    const bom = '\uFEFF'; // UTF-8 BOM
                    const blob = new Blob([bom + res.data], { type: 'text/csv;charset=utf-8;' });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = 'ユーザーマスタ_' + moment(new Date().toISOString()).format('YYYYMMDDHHmmss') + '.csv';  // 指定下载的文件名
                    link.click();
                } else {
                    ElMessage.error('CSVエクスポート失敗しました。');
                }
            }
            catch (error) {
                ElMessage.error('CSVエクスポート失敗しました。');
            }
        };

        const handleExportButton = () => {
            ElMessageBox.confirm('ユーザーマスタをエクスポートしますか？', 'CSVエクスポート', {
                confirmButtonText: 'エクスポート',
                cancelButtonText: 'キャンセル',
                type: 'warning',
            }).then(() => {
                exportUser();
            }).catch(() => {
                // console.log('削除キャンセル');
            });
        };

        const handleImportButton = (file: UploadFile) => {
            if (file.raw) {
                const formData = new FormData()
                formData.append('file', file.raw)

                //文件过大 100K
                if (file.raw.size > CSV_MAX_SIZE) {
                    ElMessage.error('ファイルが大きすぎます。');
                    return;
                }
                loading.value = true;
                axios.post('/api/users/import', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then((res: AxiosResponse<ImportResponseData>) => {
                    if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                        getUserList();
                        ElMessage.success('CSVインポート成功');
                    } else {
                        ElMessage.error('CSVインポート失敗しました。');
                    }

                }).catch(error => {
                    ElMessage.error('CSVインポート失敗しました。');
                }).finally(() => {
                    loading.value = false;
                })

            } else {
                ElMessage.error('ファイルが無効です')
            }
        }

        return {
            loginUserRole,
            searchForm,
            form,
            dialogFormVisible,
            loading,
            mTableData,
            mCurrentPage,
            mPageSize,
            mTotalPages,
            mTotalRecords,
            handleSearchButton,
            handleAddButton,
            handleEditButton,
            handleDeleteButton,
            handleStatusChange,
            handleSizeChange,
            handlePageChange,
            handleAddUpdateSubmit,
            handleExportButton,
            handleImportButton,
            formRef,
            rules,
            SYSTEM_ORGANIZATION,
            loginUserId,
            ROLES,
            loginUserRoleIsHead,
            usernameInput,
            drawer,
            moment,
            handleSort,
            getSortLabel,
            getSortIcon,
            sortField,
            sortOrder,
            isEdit,
        }
    }
});
</script>

<style scoped>
.sort-header {
    cursor: pointer;
    user-select: none;
    transition: background-color 0.2s;
    white-space: nowrap;
    display: flex;
    align-items: center;
}

.sort-header:hover {
    background-color: #f5f7fa;
}

/* 确保表头内容不换行 */
:deep(.el-table .el-table__header-wrapper .el-table__header th) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* 手机端排序按钮样式 */
.mobile-sort-btn {
    padding: 1px 4px;
    font-size: 11px;
    border-radius: 3px;
    transition: all 0.2s;
    white-space: nowrap;
    min-width: auto;
    height: 20px;
    line-height: 1;
    background-color: white;
    border: 1px solid #d1d5db;
}

.mobile-sort-btn:hover {
    background-color: #f8f9fa;
    color: #409eff;
    border-color: #409eff;
}

.mobile-sort-btn.active {
    background-color: #e6f7ff;
    color: #409eff;
    border-color: #409eff;
}
</style>